import React from 'react';
import { Step } from 'react-joyride';

import Link from '@buyside/components/presentation/Link/link';

import { quickPositionsPageUrl } from '@buyside/util/urlHelper';

export enum EntityShowJoyrideTarget {
  BUYSIDE_CONSENSUS = 'joyrideTargetSearchFilters',
  CREATE_QUICK_POSITION = 'joyrideTargetCreateQuickPosition'
}

export const entityShowJoyrideSteps: {
  buysideConsensus: Step;
  createQuickPosition: Step;
} = {
  buysideConsensus: {
    title: 'Buyside Consensus',
    target: `[data-joyride-target="${EntityShowJoyrideTarget.BUYSIDE_CONSENSUS}"]`,
    placement: 'auto',
    content: 'Unlock data on your favorite companies by answering Buyside Consensus Questions.'
  },
  createQuickPosition: {
    title: 'Quick Positions',
    target: `[data-joyride-target="${EntityShowJoyrideTarget.CREATE_QUICK_POSITION}"]`,
    placement: 'auto',
    content: (
      <>
        Build your position portfolio and track the return performance through your{' '}
        {<Link to={quickPositionsPageUrl()}>quick positions dashboard</Link>}. Once you take a
        position, you will be able to see the community sentiment on the security.
      </>
    ),
    disableBeacon: true
  }
};
